<template>
  <Loading
    :active="loadingShow"
    :is-full-page="false"
    :opacity="0.8"
    background-color="#161D31"
  >
    <div slot="default">
      <BSpinner

        style="width: 3rem; height: 3rem;"
        type="grow"
        variant="primary"
      />
    </div>
  </Loading>
</template>
<script>
import Loading from 'vue-loading-overlay'
import { BSpinner } from 'bootstrap-vue'

export default {
  name: 'MyLoading',
  components: { Loading, BSpinner },
  props: {
    loadingShow: {
      type: Boolean,
      default: () => false,
    },
  },
}
</script>
